// Large Signs
const zeroValueLarge = document.getElementById(
  "Option-template--17904013443328__main-0"
);

const submitBtnOnLargeSigns = document.getElementById(
  "ProductSubmitButton-template--17904013443328__main"
);

if (zeroValueLarge != null && zeroValueLarge.value == "0 Character") {
  submitBtnOnLargeSigns.addEventListener("click", function (event) {
    if (zeroValueLarge.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueLarge.addEventListener("change", function () {
    if (zeroValueLarge.value != "0 Character") {
      submitBtnOnLargeSigns.onclick = null;
    }
  });
}

//Medium Signs
const zeroValueMedium = document.getElementById(
  "Option-template--17904013508864__main-0"
);

const submitBtnOnMediumSigns = document.getElementById(
  "ProductSubmitButton-template--17904013508864__main"
);

if (zeroValueMedium != null && zeroValueMedium.value == "0 Character") {
  submitBtnOnMediumSigns.addEventListener("click", function (event) {
    if (zeroValueMedium.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueMedium.addEventListener("change", function () {
    if (zeroValueMedium.value != "0 Character") {
      submitBtnOnMediumSigns.onclick = null;
    }
  });
}

//Small Signs
const zeroValueSmall = document.getElementById(
  "Option-template--17904013705472__main-0"
);

const submitBtnOnSmallSigns = document.getElementById(
  "ProductSubmitButton-template--17904013705472__main"
);

if (zeroValueSmall != null && zeroValueSmall.value == "0 Character") {
  submitBtnOnSmallSigns.addEventListener("click", function (event) {
    if (zeroValueSmall.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueSmall.addEventListener("change", function () {
    if (zeroValueSmall.value != "0 Character") {
      submitBtnOnSmallSigns.onclick = null;
    }
  });
}

//Mini Signs
const zeroValueMini = document.getElementById(
  "Option-template--17904013672704__main-0"
);

const submitBtnOnMiniSigns = document.getElementById(
  "ProductSubmitButton-template--17904013672704__main"
);

if (zeroValueMini != null && zeroValueMini.value == "0 Character") {
  submitBtnOnMiniSigns.addEventListener("click", function (event) {
    if (zeroValueMini.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueMini.addEventListener("change", function () {
    if (zeroValueMini.value != "0 Character") {
      submitBtnOnMiniSigns.onclick = null;
    }
  });
}

//Custom Hats
const zeroValueCustomHats = document.getElementById(
  "Option-template--17904013803776__main-0"
);

const submitBtnOnCustomHats = document.getElementById(
  "ProductSubmitButton-template--17904013803776__main"
);

if (zeroValueCustomHats != null && zeroValueCustomHats.value == "0 Character") {
  submitBtnOnCustomHats.addEventListener("click", function (event) {
    if (zeroValueCustomHats.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueCustomHats.addEventListener("change", function () {
    if (zeroValueCustomHats.value != "0 Character") {
      submitBtnOnCustomHats.onclick = null;
    }
  });
}

//DoorKnob
const zeroValueDoorKnob = document.getElementById(
  "Option-template--17904013082880__main-0"
);

const submitBtnOnDoorKnob = document.getElementById(
  "ProductSubmitButton-template--17904013082880__main"
);

if (zeroValueDoorKnob != null && zeroValueDoorKnob.value == "0 Character") {
  submitBtnOnDoorKnob.addEventListener("click", function (event) {
    if (zeroValueDoorKnob.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueDoorKnob.addEventListener("change", function () {
    if (zeroValueDoorKnob.value != "0 Character") {
      submitBtnOnDoorKnob.onclick = null;
    }
  });
}

//Desktop Plaque
const zeroValueDPlaque = document.getElementById(
  "Option-template--17904013148416__main-0"
);

const submitBtnOnDPlaque = document.getElementById(
  "ProductSubmitButton-template--17904013148416__main"
);

if (zeroValueDPlaque != null && zeroValueDPlaque.value == "0 Character") {
  submitBtnOnDPlaque.addEventListener("click", function (event) {
    if (zeroValueDPlaque.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueDPlaque.addEventListener("change", function () {
    if (zeroValueDPlaque.value != "0 Character") {
      submitBtnOnDPlaque.onclick = null;
    }
  });
}

//Special Event
const zeroValueSpecialEvent = document.getElementById(
  "Option-template--17904013279488__main-0"
);

const submitBtnOnSpecialEvent = document.getElementById(
  "ProductSubmitButton-template--17904013279488__main"
);

if (
  zeroValueSpecialEvent != null &&
  zeroValueSpecialEvent.value == "0 Letters"
) {
  submitBtnOnSpecialEvent.addEventListener("click", function (event) {
    if (zeroValueSpecialEvent.value == "0 Letters") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueSpecialEvent.addEventListener("change", function () {
    if (zeroValueSpecialEvent.value != "0 Letters") {
      submitBtnOnSpecialEvent.onclick = null;
    }
  });
}

//Address Plaque
const zeroValueAPlaque = document.getElementById(
  "Option-template--17904012919040__main-0"
);

const submitBtnOnAPlaque = document.getElementById(
  "ProductSubmitButton-template--17904012919040__main"
);

if (zeroValueAPlaque != null && zeroValueAPlaque.value == "0 Character") {
  submitBtnOnAPlaque.addEventListener("click", function (event) {
    if (zeroValueAPlaque.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueAPlaque.addEventListener("change", function () {
    if (zeroValueAPlaque.value != "0 Character") {
      submitBtnOnAPlaque.onclick = null;
    }
  });
}

//Mini Oar
const zeroValueMiniOar = document.getElementById(
  "Option-template--17904012984576__main-0"
);

const submitBtnOnMiniOar = document.getElementById(
  "ProductSubmitButton-template--17904012984576__main"
);

if (zeroValueMiniOar != null && zeroValueMiniOar.value == "0 Character") {
  submitBtnOnMiniOar.addEventListener("click", function (event) {
    if (zeroValueMiniOar.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueMiniOar.addEventListener("change", function () {
    if (zeroValueMiniOar.value != "0 Character") {
      submitBtnOnMiniOar.onclick = null;
    }
  });
}

//Custom Oar
const zeroValueCustomOar = document.getElementById(
  "Option-template--17904013050112__main-0"
);

const submitBtnOnCustomOar = document.getElementById(
  "ProductSubmitButton-template--17904013050112__main"
);

if (zeroValueCustomOar != null && zeroValueCustomOar.value == "0 Character") {
  submitBtnOnCustomOar.addEventListener("click", function (event) {
    if (zeroValueCustomOar.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueCustomOar.addEventListener("change", function () {
    if (zeroValueCustomOar.value != "0 Character") {
      submitBtnOnCustomOar.onclick = null;
    }
  });
}

//Custom Flag
const zeroValueCustomFlag = document.getElementById(
  "Option-template--17904013115648__main-0"
);

const submitBtnOnCustomFlag = document.getElementById(
  "ProductSubmitButton-template--17904013115648__main"
);

if (zeroValueCustomFlag != null && zeroValueCustomFlag.value == "0 Character") {
  submitBtnOnCustomFlag.addEventListener("click", function (event) {
    if (zeroValueCustomFlag.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueCustomFlag.addEventListener("change", function () {
    if (zeroValueCustomFlag.value != "0 Character") {
      submitBtnOnCustomFlag.onclick = null;
    }
  });
}

//Children's Room
const zeroValueChildrensRoom = document.getElementById(
  "Option-template--17904012951808__main-0"
);

const submitBtnOnChildrensRoom = document.getElementById(
  "ProductSubmitButton-template--17904012951808__main"
);

if (
  zeroValueChildrensRoom != null &&
  zeroValueChildrensRoom.value == "0 Character"
) {
  submitBtnOnChildrensRoom.addEventListener("click", function (event) {
    if (zeroValueChildrensRoom.value == "0 Character") {
      event.preventDefault();
      alert(
        "Please update the Character Count - Every Letter is a Separate Block"
      );
    }
  });

  zeroValueChildrensRoom.addEventListener("change", function () {
    if (zeroValueChildrensRoom.value != "0 Character") {
      submitBtnOnChildrensRoom.onclick = null;
    }
  });
}

//Load SKU immediately

// const productSku = document.getElementById(
//   "Sku-template--17904013508864__main"
// );

// if (productSku != null) {
//   const variantSku = document.getElementById(
//     "Option-template--17904013508864__main-0"
//   );

//   variantSku.addEventListener("change", function () {
//     console.log(variantSku.value);
//     console.log(productSku.style.display);
//     if (variantSku.value != "0 Character") {
//       productSku.style.visibility = "visible";
//     }
//   });
// }

//Load SKU immediately targeting class

const productSkuClass = document.querySelector(".product__sku");
const selectSelectThatIsZero = document.querySelector(".select__select");

if (productSkuClass) {
  selectSelectThatIsZero.addEventListener("change", function () {
    if (selectSelectThatIsZero.value != "0 Character") {
      productSkuClass.style.visibility = "visible";
    } else {
      productSkuClass.style.visibility = "hidden";
    }
  });
} else {
  console.log("No element with class '.product__sku' found.");
}
